module.exports = __webpack_public_path__ + "img/IFOP-Logo.9190dc97.svg";